// extracted by mini-css-extract-plugin
export default {"tabRegion":"FormTab_tabRegion__fJlmX"};